'use client'
import React from 'react'
import Image from 'next/image'

import { PrismicRichText } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'

type DataObject = Record<string, any>

const MarketingCtaComponent = ({ data }: { data: DataObject }) => {
  return (
    <section className="pb-20 pt-20 lg:pb-[120px]">
      <div className="container">
        <div className="grid gap-10 lg:grid-cols-2">
          <div className="[&>h2]:mb-10 [&>h2]:bg-gradient-to-r [&>h2]:from-primary-green-85 [&>h2]:to-primary-ink-100 [&>h2]:bg-clip-text [&>h2]:text-transparent [&>h2]:lg:leading-[64px] [&>h2_em]:block [&>h2_em]:not-italic">
            <PrismicRichText field={data.primary.title} />
            <button
              className="btn btn-default btn-primary btn-interaction mt-0 !w-fit lg:mt-10"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              {data.primary.button.text}
              <Image src="/images/angle-right-green.svg" width={20} height={16} alt="" aria-hidden="true" />
            </button>
          </div>

          <PrismicNextImage field={data.primary.image} className="mt-4 lg:mt-0" fallbackAlt="" />
        </div>
      </div>
    </section>
  )
}

export default MarketingCtaComponent
